<template>
  <div class="learning-path-card">
    <b-card>
      <div class="content">
        <div class="top-card">
          <div>
            <svg
              width="52"
              height="53"
              viewBox="0 0 52 53"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_75_9818)">
                <path
                  d="M0.716553 33.351C0.914633 32.2735 1.04967 31.18 1.32095 30.1214C3.06307 23.3229 8.98546 18.157 15.9646 17.309C25.2127 16.1852 33.5592 22.2538 35.3418 31.3979C37.178 40.8167 30.7279 50.1624 21.2635 51.7936C20.6594 51.8978 20.0526 51.986 19.4471 52.0815C18.5791 52.0815 17.711 52.0815 16.8428 52.0815C16.4683 52.0204 16.0949 51.9504 15.719 51.8996C8.73315 50.9538 2.85671 45.6506 1.22932 38.7948C1.00746 37.8604 0.885115 36.9023 0.716553 35.9552C0.716553 35.0871 0.716553 34.2191 0.716553 33.351ZM33.446 34.6363C33.419 26.1663 26.5468 19.3221 18.1 19.3534C9.674 19.3845 2.89143 26.2555 2.91788 34.7336C2.94379 43.0538 9.82012 49.9023 18.1252 49.8797C26.6176 49.8565 33.4727 43.036 33.446 34.6363Z"
                  fill="#F6C225"
                />
                <path
                  d="M52.0001 16.1229C51.8332 16.9862 51.7164 17.8627 51.4916 18.7105C49.8794 24.7888 44.265 29.134 38.0198 29.1629C37.1885 29.1668 36.6645 28.6983 36.7195 28.0007C36.7683 27.3818 37.2283 26.9803 37.9715 26.9705C39.3708 26.9521 40.7232 26.6994 42.031 26.21C47.0147 24.345 50.2709 19.2249 49.7696 14.0501C49.2303 8.48154 45.2709 4.12804 39.8895 3.18625C32.6802 1.92457 26.052 7.31897 25.8364 14.6235C25.8083 15.5796 25.4033 16.102 24.7018 16.087C23.9877 16.0718 23.6187 15.5502 23.6379 14.5833C23.7719 7.84229 28.8973 1.99016 35.5452 0.986128C35.9227 0.929095 36.2985 0.861109 36.6751 0.798065C37.4429 0.798065 38.2109 0.798065 38.9788 0.798065C39.09 0.82745 39.1995 0.871795 39.3126 0.88435C45.229 1.53496 50.0254 5.66153 51.5319 11.4256C51.7371 12.2107 51.8463 13.0208 52.0001 13.8193C52.0001 14.5871 52.0001 15.3549 52.0001 16.1229Z"
                  fill="#F6C225"
                />
                <path
                  d="M52 33.0505C51.8343 34.0848 51.7197 35.1305 51.4945 36.1519C49.8553 43.5863 44.0418 49.6642 36.4728 51.0203C35.8994 51.123 35.3188 51.1918 34.7391 51.2525C34.0536 51.3244 33.5155 50.9041 33.4597 50.2808C33.4012 49.6278 33.8088 49.1283 34.5058 49.0727C42.3936 48.4431 48.5374 41.7898 49.5938 34.1973C49.7425 33.1286 49.7534 32.0378 49.7792 30.9561C49.8003 30.0755 50.0013 29.6608 50.6089 29.4997C51.1738 29.3499 51.5866 29.6011 52 30.3463C52 31.2476 52 32.149 52 33.0505Z"
                  fill="#F6C225"
                />
                <path
                  d="M21.8509 0.797928C21.9781 0.826912 22.104 0.869119 22.2328 0.882877C22.9371 0.958075 23.3872 1.42623 23.3438 2.04772C23.2989 2.69045 22.7653 3.09302 22.0461 3.07993C21.0638 3.06217 20.0746 3.00714 19.0993 3.09262C11.9951 3.71491 6.10599 8.65584 4.24486 15.5507C4.00257 16.4482 3.88903 17.3811 3.73262 18.3005C3.61709 18.9797 3.11554 19.406 2.49018 19.3234C1.86775 19.2411 1.46545 18.684 1.55294 18.0105C2.36569 11.7507 5.428 6.91132 10.7711 3.55316C13.2377 2.00297 15.9573 1.14093 18.8645 0.886082C18.9935 0.874729 19.1193 0.828114 19.2468 0.797928C20.1148 0.797928 20.9829 0.797928 21.8509 0.797928Z"
                  fill="#F6C225"
                />
                <path
                  d="M42.1819 18.3853C42.1811 20.0664 41.1374 21.6218 39.5519 22.2347C39.0996 22.4096 38.8878 22.6507 38.8891 23.1493C38.891 23.8099 38.4513 24.2378 37.8447 24.2528C37.2349 24.2679 36.7608 23.8773 36.7285 23.2172C36.703 22.6985 36.4845 22.4673 36.0122 22.2916C34.8838 21.8721 34.0736 21.0783 33.5822 19.9745C33.2976 19.3352 33.5063 18.7097 34.0776 18.4429C34.6331 18.1833 35.2521 18.3825 35.5392 19.0043C36.2207 20.4799 38.0045 20.74 39.1501 19.9555C40.1068 19.3004 40.3116 18.2035 39.4988 17.3873C38.9735 16.8597 38.2907 16.4512 37.6143 16.1207C36.6229 15.6359 35.6184 15.1954 34.8169 14.4085C32.5903 12.2225 33.1497 9.03451 36.0083 7.78084C36.5132 7.55939 36.7156 7.29212 36.7309 6.74729C36.749 6.11312 37.2685 5.68744 37.8544 5.71161C38.4274 5.73525 38.8641 6.15559 38.8895 6.78416C38.9083 7.25044 39.0948 7.49834 39.541 7.65636C40.7163 8.07242 41.5446 8.88878 42.052 10.0229C42.3335 10.6524 42.1042 11.2787 41.5239 11.5368C40.9571 11.7887 40.3347 11.5767 40.0785 10.9484C39.5428 9.63462 37.8589 9.30311 36.7081 9.85555C35.5692 10.4024 35.177 12.0292 36.342 12.8553C36.9633 13.296 37.6585 13.6319 38.3176 14.0196C39.1202 14.4919 39.9625 14.9111 40.7106 15.4584C41.7241 16.2003 42.1825 17.229 42.1819 18.3853Z"
                  fill="#F6C225"
                />
                <path
                  d="M24.1972 31.6345C24.0903 32 23.9511 32.6336 23.7176 33.2304C23.4622 33.883 23.4435 33.9518 23.9874 34.3552C25.5126 35.4864 26.1585 37.3782 25.6256 39.1533C25.0935 40.9252 23.5163 42.1505 21.6227 42.2625C21.0643 42.2956 20.9298 42.4336 20.9218 43.0025C20.9156 43.4365 20.9298 43.8708 20.9172 44.3045C20.8958 45.0418 20.4428 45.5384 19.8101 45.5368C19.1687 45.5353 18.7359 45.0463 18.7239 44.2989C18.717 43.8649 18.7284 43.4307 18.7203 42.9969C18.7099 42.4467 18.539 42.2737 18.0041 42.2667C17.5534 42.2608 17.1027 42.2684 16.652 42.2648C16.2142 42.2613 16.0099 42.48 16.0119 42.9114C16.0141 43.3954 16.024 43.88 16.0071 44.3637C15.9815 45.0966 15.5112 45.5838 14.8735 45.5642C14.2487 45.5448 13.8305 45.0697 13.8166 44.3503C13.8085 43.9332 13.8168 43.5157 13.8138 43.0984C13.8091 42.4208 13.6596 42.2687 12.9975 42.2657C12.5468 42.2637 12.0956 42.2755 11.6454 42.2613C10.9708 42.2401 10.5222 41.7977 10.5186 41.1721C10.515 40.5475 10.9654 40.0911 11.6317 40.0692C12.0987 40.0539 12.5664 40.0684 13.0339 40.0647C13.6402 40.06 13.8105 39.8985 13.8125 39.2955C13.8177 37.7764 13.8144 36.2572 13.8144 34.7381C13.8144 33.169 13.816 31.5997 13.8136 30.0305C13.8125 29.3269 13.6594 29.1744 12.9666 29.1696C12.5159 29.1663 12.0645 29.1804 11.6146 29.1601C11.0038 29.1326 10.5635 28.6957 10.5375 28.1232C10.511 27.5355 10.9429 27.0351 11.5706 26.9889C12.0688 26.9523 12.5716 26.9816 13.0723 26.9721C13.6457 26.9613 13.8042 26.7982 13.813 26.214C13.8198 25.7633 13.8051 25.3123 13.819 24.8619C13.8389 24.2185 14.271 23.7623 14.8615 23.7384C15.4496 23.7147 15.944 24.1407 15.9935 24.7745C16.0337 25.289 16.013 25.8087 16.0111 26.326C16.0095 26.7607 16.2123 26.973 16.6523 26.9664C17.1196 26.9594 17.5872 26.9577 18.0545 26.9669C18.5245 26.9762 18.7202 26.7314 18.7216 26.2885C18.7232 25.8044 18.7127 25.32 18.7274 24.8362C18.7475 24.176 19.1625 23.7408 19.7675 23.7205C20.4003 23.6993 20.8645 24.1142 20.9072 24.7932C20.9407 25.3253 20.9451 25.8627 20.9128 26.3947C20.882 26.9018 21.074 27.1639 21.5493 27.3749C23.2559 28.1332 24.0911 29.5001 24.1972 31.6345ZM19.1981 35.7303C18.3646 35.7303 17.531 35.7244 16.6975 35.7324C16.1557 35.7376 16.0185 35.8747 16.0141 36.4229C16.0061 37.4064 16.0059 38.39 16.0143 39.3735C16.0189 39.9031 16.178 40.0616 16.7054 40.0632C18.289 40.0683 19.8729 40.0751 21.4563 40.0597C22.7349 40.0473 23.5864 39.1798 23.5993 37.9149C23.6122 36.636 22.7526 35.7566 21.4485 35.7332C20.6986 35.7198 19.9482 35.7308 19.1981 35.7303ZM18.2947 29.2204C18.2947 29.2036 18.2946 29.1869 18.2946 29.1701C17.7451 29.1701 17.1956 29.1655 16.6461 29.1716C16.2526 29.1758 16.0152 29.3596 16.0145 29.7773C16.0129 30.8263 16.0143 31.8754 16.0139 32.9244C16.0138 33.2856 16.2048 33.5173 16.551 33.5181C17.7819 33.5213 19.0183 33.5597 20.2418 33.4557C21.2996 33.3658 21.9606 32.4599 21.9598 31.3464C21.959 30.2336 21.2924 29.365 20.2375 29.2349C19.5989 29.1562 18.9428 29.2204 18.2947 29.2204Z"
                  fill="#F6C225"
                />
              </g>
              <defs>
                <clipPath id="clip0_75_9818">
                  <rect
                    width="51.2835"
                    height="51.2835"
                    fill="white"
                    transform="translate(0.716553 0.797928)"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div>
            <span>6 Lessons</span>
          </div>
        </div>
        <div class="title">
          <h4>Advanced</h4>
          <span>Learn only the essentials to trade crypto, nothing more.</span>
        </div>
        <div class="action">
          <span> View Details </span>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "LearningPathCard",
};
</script>

<style lang="scss" scoped>
.learning-path-card {
  .card {
    border-radius: 20px;
    border-color: #ffffff;
    min-height: 200px;
    padding: 22px 20px 19px 20px;
  }
  .card-body {
    padding: 0;
    margin: 0;
  }
  .content {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .top-card {
    display: flex;
    justify-content: space-between;
  }
  .title {
    h4 {
      color: #000000;
      margin-bottom: 10px;
      font-size: 20px;
      line-height: 24px;
    }
    span {
      color: #979797;
      font-size: 14px;
      line-height: 20px;
    }
  }
  .action {
    span {
      cursor: pointer;
      font-weight: bold;
      color: #024089;
    }
  }
}
</style>
